<div class="flex flex-col gap-10">
  <!-- Main Title - Only shown when not hidden -->
  @if (!hideTitle()) {
    <h2 class="mb-8 text-3xl font-medium text-neutral-800">
      {{
        'pages.magazinesAndJournals.accordionSections.moreInformation'
          | translate
      }}
    </h2>
  }

  @if (shouldShowSection(magazine.preface)) {
    <div class="flex items-start gap-5 pb-7">
      <div class="w-2/5 pr-4">
        <div class="text-lg font-semibold text-black">
          {{
            'pages.magazinesAndJournals.cta.moreInfo.introduction' | translate
          }}
        </div>
      </div>
      <div class="w-3/5">
        <div
          class="text-base leading-normal font-normal text-neutral-800"
          [innerHTML]="magazine.preface"
        ></div>
      </div>
    </div>
  }

  @if (shouldShowSection(magazine.subject)) {
    <div class="flex items-start gap-5 pb-7">
      <div class="w-2/5 pr-4">
        <div class="text-lg font-semibold text-black">
          {{ 'pages.magazinesAndJournals.cta.moreInfo.content' | translate }}
        </div>
      </div>
      <div class="w-3/5">
        <div
          class="text-base leading-normal font-normal text-neutral-800"
          [innerHTML]="magazine.subject"
        ></div>
      </div>
    </div>
  }
</div>
